import { render } from "./WhiteBoardCard.vue?vue&type=template&id=6ed5441a&scoped=true"
import script from "./WhiteBoardCard.vue?vue&type=script&lang=js"
export * from "./WhiteBoardCard.vue?vue&type=script&lang=js"

import "./WhiteBoardCard.vue?vue&type=style&index=0&id=6ed5441a&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5441a"]])

export default __exports__